import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { FuseAlertAppearance, FuseAlertType } from '@fuse/components/alert';
import { SnackbarMsgComponent } from './snackbar-msg.component';
import { ISnackbarMsgConfig } from './snackbar-msg.interface';

@Injectable({
  providedIn: 'root'
})
export class SnackbarMsgService {
  private readonly _horizontalPosition: MatSnackBarHorizontalPosition = "end";
	private readonly _verticalPosition: MatSnackBarVerticalPosition = "top";

	constructor(
		private readonly _snackBar: MatSnackBar
	) {}

	success(title: string, message: string, appearance: FuseAlertAppearance = "fill") {
		const config = this._buildConfig(title, message, appearance, "success");

		this._openSnackbar(config);
	}

	error(title: string, message: string, appearance: FuseAlertAppearance = "fill") {
		const config = this._buildConfig(title, message, appearance, "error");

		this._openSnackbar(config);
	}

	private _openSnackbar(data: ISnackbarMsgConfig) {
		this._snackBar.openFromComponent(SnackbarMsgComponent, {
			data: data,
			duration: 5000,
			panelClass: ["fuse-snackbar"],
			horizontalPosition: this._horizontalPosition,
			verticalPosition: this._verticalPosition
		});
	}

	private _buildConfig(title: string, message: string, appearance: FuseAlertAppearance, type: FuseAlertType) {
		return {
			title: title,
			message: message,
			appearance: appearance,
			type: type 
		} as ISnackbarMsgConfig;
	}

}
